// 1.00		500
// 5.00		300
// 10.00		250
// 20.00		250
// 50.00		200
// 100.00		200
// 150.00		180
// 200.00		180
export const algoritemPrice = (x) => {
  if (0 < x && x <= 1) {
    return Number((x * 5).toFixed(1));
  } else if (1 < x && x <= 5) {
    return Number((x * 3).toFixed(1));
  } else if (5 < x &&x <= 10) {
    return Number((x * 2.5).toFixed(1));
  } else if (10 < x &&x <= 20) {
    return Math.round(x * 2.5);
  } else if (20 < x &&x <= 50) {
    return Math.round(x * 2);
  } else if (50 < x &&x <= 100) {
    return Math.round(x * 2);
  } else if (100 < x &&x <= 150) {
    return Math.round(x * 1.8);
  } else if (150 < x &&x <= 200) {
    return Math.round(x * 1.8);
  }else{
    return x;
  }
};
const test = algoritemPrice(0.5)
console.log(test);
export const  priceFormatter = new Intl.NumberFormat('en-IL', {
  style: 'currency',
  currency: 'ILS',
});